export const SOCIAL_LINKS = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/1BB9NZ4dKB/?mibextid=wwXIfr',
  },
  {
    label: 'TikTok',
    href: 'https://tiktok.com/@hristiyanaivanovatarot',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/hristiyanaivanovatarot/',
  },
] as const;
